import React, { useEffect, useState } from 'react'

import {
	Button,
	Card,
	CardHeader,
	CardBody,
	CardTitle,
	FormGroup,
	Input,
	Row,
	Col,
	Label,
	FormFeedback,
} from "reactstrap";

import useForm from "../../formValidator/userForm";
import "./styles.css";

import Loader from '../../components/Loader'

import { DEPARTMENT, CATEGORY, SCHEME } from '../../configs/urls'
import { STATUS_LIST } from '../../configs/constant'
import { getApi, postApi, putApi } from '../../services/api'
import { useHistory } from 'react-router-dom'
import axios from 'axios'

const SchemesOperations = (props) => {
	const [isRequesting, setIsRequestig] = useState(false)
	const [actionTitle, setActionTitle] = useState('Add Scheme')
	const history = useHistory()
	const [categories, setCategories] = useState([])
	const [departments, setDepartments] = useState([])

	useEffect(() => {
		getAllData()

		if (props.match && props.match.params && !props.match.params.scheme_id) {
			params.status = 1
		}
	}, [])

	const getAllData = () => {
		const category = getApi(CATEGORY)
		const department = getApi(DEPARTMENT)

		let scheme
		if (props.match && props.match.params && props.match.params.scheme_id) {
			const url = `${SCHEME}/${props.match.params.scheme_id}`
			scheme = getApi(url)
			setActionTitle('Update Scheme')
		}
		axios.all([scheme, category, department]).then(res => {

			if (res[0] && res[0].data) {
				const {
					name,
					department_id,
					category_id,
					status
				} = res[0].data;
				params.name = name;
				params.department_id = department_id
				params.category_id = category_id;
				params.status = status;
			}

			if (res[1] && res[1].data != null) {
				setCategories(res[1].data)
			}

			if (res[2] && res[2].data) {
				setDepartments(res[2].data)
			}
		})
	};

	const validate = (values) => {
		let errors = {};

		if (!values.name) {
			errors.name = "Scheme Name is required";
		}

		if (!values.department_id || values.department_id < 0) {
			errors.department_id = "Please select department";
		}

		if (!values.category_id || values.category_id < 0) {
			errors.category_id = "Please select category";
		}

		if (!values.status || values.status < 0) {
			errors.status = "Please select Scheme Status";
		}

		return errors;
	};

	const saveUpdateScheme = () => {
		setIsRequestig(true);

		if (props.match && props.match.params && props.match.params.scheme_id) {
			putApi(`${SCHEME}/${props.match.params.scheme_id}`, params).then((res) => {
				history.goBack()
			}, () => {

			}).finally(() => {
				setIsRequestig(false);
			});
		} else {
			postApi(SCHEME, params)
				.then(
					(res) => {
						history.goBack()
					},
					(err) => { }
				)
				.finally(() => {
					setIsRequestig(false);
				});
		}
	}

	const { params, errors, handleChange, handleSubmit } = useForm(
		saveUpdateScheme,
		validate
	);

	return (
		<div className="content">
			<Loader isLoading={isRequesting} />
			<form onSubmit={handleSubmit}>
				<Card className="card-user">
					<CardHeader>
						<CardTitle tag="h5">{actionTitle}</CardTitle>
					</CardHeader>
					<hr />
					<CardBody>
						<Row>
							<Col className="pr-1" md="6">
								<FormGroup>
									<label>Scheme Name</label>
									<Input
										type="text"
										name="name"
										placeholder="Scheme Name"
										value={params.name || ""}
										onChange={handleChange}
										invalid={errors.name && errors.name.length > 0 ? true : false}
									/>
									<FormFeedback>{errors.name}</FormFeedback>
								</FormGroup>
							</Col>
							<Col className="pr-1" md="6">
								<FormGroup>
									<Label for="districtName">Department</Label>
									<Input
										type="select"
										id="districtName"
										name="department_id"
										value={params.department_id}
										onChange={handleChange}
										invalid={errors.department_id && errors.department_id.length > 0 ? true : false}
									>
										<option value={-1}>Select Department</option>
										{
											departments.map(department => (
												<option key={department.id} value={department.id}>{department.name}</option>
											))
										}
									</Input>
									<FormFeedback>{errors.department_id}</FormFeedback>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col className="pr-1" md="6">
								<FormGroup>
									<Label for="status">Status</Label>
									<Input
										type="select"
										name="status"
										id="status"
										value={params.status}
										onChange={handleChange}
										invalid={errors.status && errors.status.length > 0 ? true : false}
									>
										{
											STATUS_LIST.map(status => (
												<option key={status.id} value={status.id}>{status.title}</option>
											))
										}
									</Input>
									<FormFeedback>{errors.status}</FormFeedback>
								</FormGroup>
							</Col>

							<Col className="pr-1" md="6">
								<FormGroup>
									<Label for="categoryName">Category</Label>
									<Input
										type="select"
										id="categoryName"
										name="category_id"
										value={params.category_id}
										onChange={handleChange}
										invalid={errors.category_id && errors.category_id.length > 0 ? true : false}
									>
										<option value={-1}>Select Category</option>
										{
											categories.map(category => (
												<option key={category.id} value={category.id}>{category.name}</option>
											))
										}
									</Input>
									<FormFeedback>{errors.category_id}</FormFeedback>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<div className="update ml-auto mr-auto">
								<Button
									className="btn-round"
									color="primary"
									type="submit"
								>
									{actionTitle}
								</Button>
							</div>
						</Row>
					</CardBody>
				</Card>
			</form>
		</div>
	)
}

export default SchemesOperations